var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.264 54.264",
    style: {
      enableBackground: "new 0 0 54.264 54.264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M52.021,49.561c-0.011-0.001-0.02-0.001-0.029,0H2.244c-0.813,0-1.563-0.439-1.959-1.15 c-0.397-0.71-0.378-1.579,0.049-2.271L25.207,5.769c0.408-0.663,1.132-1.066,1.911-1.066c0.777,0,1.502,0.403,1.91,1.066 l24.704,40.098c0.332,0.392,0.532,0.897,0.532,1.451C54.265,48.556,53.261,49.561,52.021,49.561z M6.263,45.073h41.709 L27.118,11.224L6.263,45.073z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M27.116,38.89c0.584,0,1.082,0.205,1.492,0.612c0.408,0.412,0.613,0.907,0.613,1.49 c0,0.586-0.217,1.081-0.648,1.493c-0.434,0.406-0.919,0.612-1.457,0.612c-0.537,0-1.022-0.206-1.455-0.612 c-0.432-0.412-0.646-0.907-0.646-1.493c0-0.583,0.203-1.078,0.613-1.49C26.036,39.094,26.532,38.89,27.116,38.89z M28.589,35.945 h-2.944V18.062h2.944V35.945z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/hazard.f87c2975343f9a4104a670935781d219.svg";
export { ForwardRef as ReactComponent };